<serviceos-ng-card *ngIf="referralStats$ | async as referralStats">
    <div class="referral-stats">
        <span class="title">
            {{texts.title}}
        </span>
        <div class="referrals-stats">
            <div class="stat" *ngFor="let stat of referralStats">
                <div class="stat-desc">
                    <div class="label">{{stat.title}}</div>
                    <div class="description">{{stat.description}}</div>
                </div>
                <div class="value">
                    <div class="label">{{stat.amount_formatted}}</div>
                </div>
            </div>
        </div>
    </div>
</serviceos-ng-card>